var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-justify-content-center"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }